import { ModalCustom } from "components/ModalCustom";
import { FaCheck } from "react-icons/fa";
import { Icone, ModalBody } from "./style";

interface IProps {
  show: boolean;
  handleClose: () => void;
}

export function ModalSucessoExcluir({ show, handleClose }: IProps) {
  return (
    <ModalCustom show={show} handleClose={handleClose} title="Remover lote" centered>
      <ModalBody>
        <Icone>
          <FaCheck />
        </Icone>
        Lote removido com sucesso.
      </ModalBody>
    </ModalCustom>
  );
}
